export default "__VITE_ASSET__mpL6A8cy__"